import Hero from "@/components/organisms/Hero";
import Image from "next/image";
import Link from "next/link";
const SectionStains = (props) => {
  let heroStyleDefault = {
    textContainer: "col-start-2 col-span-10 order-1",
    titleContainer: "col-start-2 col-span-10 order-2",
    paragraphsContainer: "col-start-2 col-span-10 order-3",
    heroContainer: "pb-8 col-span-12 md:col-start-2 md:col-span-10",
  };
  const title = props.title
    ? {
        title: props.title?.text || "Lorem ipsum dolor sit amet",
        className: props.title?.className || "",
        tag: props.title?.tag || undefined
      }
    : false;
  const subtitle = props.subtitle
    ? {
        subtitle: props.subtitle?.text || "Lorem ipsum dolor sit amet",
        className: props.subtitle?.className || "section-subtitle text-center",
      }
    : false;
  const link = props.link
    ? {
        link: props.link?.text || "Lorem ipsum dolor sit amet",
        className: props.link?.className || "hero-link",
        href: props.link?.href || "#",
      }
    : false;
  const paragraphs =
    props.paragraphs && Array.isArray(props.paragraphs.list)
      ? {
          list: props.paragraphs?.list || "",
          className: props.paragraphs?.className || "hero-text mb-4",
        }
      : false;
  const mainImage = props.mainImage
    ? {
        mainImage: props.mainImage.mainImage || weddingsSliderSecond,
      }
    : false;
  const containers = {
    sectionContainer: props?.styles?.sectionContainer || "pt-12",
    sectionCardContainer:
      props?.styles?.sectionCardContainer || "base-container base-grid",
    sectionContainerImagesMain:
      props?.styles?.sectionContainerImagesMain ||
      "col-span-12 order-2 order-1 md:order-2 md:col-start-7 md:col-span-5 md:py-6 overflow-hidden",
    containerImageLeafRight:
      props?.styles?.containerImageLeafRight ||
      "z-[-1] relative md:absolute w-48 h-48 rounded-lg 2xl:translate-x-[27rem] 2xl:translate-y-[-1rem]  xl:translate-x-[23rem] xl:translate-y-[-2rem] lg:translate-x-[18rem] lg:translate-y-[-2rem] md:translate-x-[10rem] md:translate-y-[-4rem] hidden md:block",
    imageClass:
      props?.styles?.imageClass ||
      "w-full object-cover wedding-group max-w-[500px] m-auto relative ",
    containerParagraphsMain:
      props?.styles?.containerParagraphsMain ||
      "col-span-12 order-2 md:col-span-4 md:order-1 md:col-start-2",
    containerParagraphsSpace:
      props?.styles?.containerParagraphsSpace ||
      "mt-2 md:mt-0 lg:mt-16 text-center md:text-left",
  };
  return (
    <section className={containers.sectionContainer}>
      <div className={containers.sectionCardContainer}>
        <Hero
          title={{
            text: title.title,
            className: title.className,
            tag: title.tag
          }}
          text={{
            text: subtitle.subtitle,
            className: subtitle.className,
          }}
          styles={{ ...heroStyleDefault }}
        />
        <div className={containers.sectionContainerImagesMain}>
          <Image
            src={mainImage.mainImage?.src}
            width={mainImage?.mainImage?.width}
            height={mainImage?.mainImage?.height}
            alt={mainImage?.mainImage?.alt}
            className={containers.imageClass}
          />
        </div>
        <div className={containers.containerParagraphsMain}>
          <div className={containers.containerParagraphsSpace}>
            {paragraphs && (
              <>
                {paragraphs.list.map((p, index) => (
                  <p
                    key={`paragraphs-list-${index}`}
                    className={paragraphs.className}
                  >
                    {p}
                  </p>
                ))}
              </>
            )}
            {link && (
              <Link className={link.className} href={link.href} id="Descubrir-grupos-eventos-cancun">
                {link.link}
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
export default SectionStains;
